import { render } from "./UserSubscription.vue?vue&type=template&id=2502dc24"
import script from "./UserSubscription.vue?vue&type=script&lang=js"
export * from "./UserSubscription.vue?vue&type=script&lang=js"

import exportComponent from "/Users/georgwidschwendter/Documents/GitHub/learn/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__